import { formatDateRangePt } from "../../../dashboard-framework/describeWidgetLogic";
import { DateRange } from "../../../dashboard-framework/types";
import { NeurofeedbackRow } from "../shared/neurofeedbackProductivityRows";

export const BRAIN_MAPS_SPECIALIZATION = "brain_maps";

const isBrainMapsTechnician = (row: NeurofeedbackRow, specializationsByUserId: Record<string, Array<string>>) => {
    const hasBrainMapsSpecialization = (specializationsByUserId[row.userId] || []).includes(BRAIN_MAPS_SPECIALIZATION);
    const isBrainMapsTechnicianRow = hasBrainMapsSpecialization || row.brainMaps > 0;
    return isBrainMapsTechnicianRow;
};

export const brainMapsCardRows = (rows: Array<NeurofeedbackRow>, specializationsByUserId: Record<string, Array<string>>) => {
    const cardRows = rows
        .filter((row) => isBrainMapsTechnician(row, specializationsByUserId))
        .sort((firstRow, secondRow) => secondRow.brainMaps - firstRow.brainMaps || firstRow.displayName.localeCompare(secondRow.displayName, "pt"));
    return cardRows;
};

export const describeBrainMapsCardPt = (range: DateRange, isOwnView: boolean) => {
    const universeText = isOwnView
        ? "Vista pessoal: só o teu cartão."
        : `Um cartão por técnico com a especialização "brain maps" na ficha de técnico ou com pelo menos um brain map no período.`;
    const description =
        `${universeText} ` +
        `Brain maps = nº de mapas cerebrais com data ${formatDateRangePt(range)} (datas em fuso de Lisboa), atribuídos ao técnico do brain map. ` +
        `Brain maps por hora = brain maps ÷ horas de tempo sem sessão no mesmo período, em que tempo sem sessão = horário lançado − tempo em sessão − reuniões/formações (nunca negativo) — o mesmo cálculo do dashboard "Aproveitamento Horário". ` +
        `"—" quando não há tempo sem sessão.`;
    return description;
};
